import { createFileRoute, redirect } from '@tanstack/react-router'

import { queryClient } from '@/api/api'
import { getFormOptions } from '@/api/codegen/@tanstack/react-query.gen'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/',
)({
  beforeLoad: async ({ params: { companyId, spaceId, projectId, formId } }) => {
    const form = await queryClient.ensureQueryData(
      getFormOptions({
        path: {
          projectID: projectId,
          formID: formId,
        },
        query: {
          expandRefs: true,
        },
      }),
    )

    throw redirect({
      to: '/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/$formVersionId',
      params: {
        companyId,
        spaceId,
        projectId,
        formId,
        formVersionId: form.formVersion.id,
      },
    })
  },
})
